import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import withWidth from '@material-ui/core/withWidth';
import { withStyles } from '@material-ui/core/styles';
// import Drawer from '@material-ui/core/Drawer';

import '../App.css';

// import Header from './Header/Header';
// import HeaderMenu from './Header/HeaderMenu';
import ThemeProvider from './Theme';
// import Footer from './Footer';
import Home from './Home/Home';
import Mission from './Mission/Mission';
import MissionFiche from './Mission/MissionFiche';
import ScrollToTopOnMount from './ScrollToTopOnMount';
import Login from './Login';
import Logout from './Logout';
import Legal from './Legal/Legal';
import {
  login as initialeLogin,
  isStateKnown as authStateKnown,
  getCurrentUserRole,
  isLoggedIn,
} from '../ducks/authentication';

const styles = {
  content: {
    position: 'relative',
    zIndex: 99,
    marginTop: -60,
    height: 'calc(100% - 400px - 40px)',
  },
  drawerPaper: {
    top: 40,
    zIndex: 998,
    borderRadius: '0 0 5px 5px',
    padding: '5px 3px',
  },
  drawerModal: {
    zIndex: 997,
  },
};
class NoMatch extends Component {
  render() {
    return (
      <div id="Error404">
        <div className="wrapper">
          <div className="content">
            <h1>Erreur 404</h1>
            <p>Page introuvable... :(</p>
          </div>
        </div>
      </div>
    );
  }
}

class App extends Component {
  constructor(props) {
    super(props);
    this.state = { panelOpened: false };
    this._panelToggle = this._panelToggle.bind(this);
    console.log("Lobster Portail v 1.1");
  }
  componentDidMount() {
    this.props.onMount();
  }
  _panelToggle() {
    this.setState({ panelOpened: !this.state.panelOpened });
  }
  render() {
    const { loggedIn, authStateKnown, userRole } = this.props;

    // const barOffset = ['xs'].indexOf(width) >= 0 ? 120 : 220;

    // const horizontalOffset = ['xs'].indexOf(width) >= 0 ? 50 : 58;

    // const sectionProps = { barOffset, horizontalOffset };
    // console.log('home render');
    return (
      <Router>
        <div className="App">
          <ThemeProvider>
            <ScrollToTopOnMount />
            <Choose>
              <When condition={!loggedIn}>
                <Switch>
                  <Route exact path={'/'} component={Home} />
                  <Route exact path={'/login'} component={Login} />
                  <Route exact path={'/logout'} component={Logout} />
                  <Route path={'/confidentialite'} component={Legal} />
                  <Route component={NoMatch} />
                </Switch>
              </When>
              <When
                condition={
                  authStateKnown !== undefined &&
                  loggedIn &&
                  (userRole === 'entreprise' || userRole === 'admin')
                }
              >
                <Switch>
                  <Route exact path={'/'} component={Home} />
                  <Route exact path={'/login'} component={Login} />
                  <Route exact path={'/logout'} component={Logout} />
                  <Route path={'/confidentialite'} component={Legal} />
                  <Route
                    exact
                    path={'/mission/:missionId?'}
                    component={({ match }) => <Mission missionId={match.params.missionId} />}
                  />
                  <Route
                    exact
                    path={'/mission/:missionId/fiche/:ficheId'}
                    component={({ match }) => (
                      <MissionFiche missionId={match.params.missionId} ficheId={match.params.ficheId} />
                    )}
                  />
                  <Route
                    exact
                    path={'/preview/a/fiche/:ficheId'}
                    component={({ match }) => (
                      <MissionFiche missionId={'preview'} ficheId={match.params.ficheId} />
                    )}
                  />
                  <Route
                    path={'/fiche/anon/:ficheId'}
                    component={({ match }) => (
                      <MissionFiche missionId={'anon'} ficheId={match.params.ficheId} />
                    )}
                  />
                  <Route component={NoMatch} />
                </Switch>
              </When>
              <When condition={authStateKnown !== undefined && loggedIn && userRole === 'candidat'}>
                <Switch>
                  <Route exact path={'/'} component={Home} />
                  <Route exact path={'/login'} component={Login} />
                  <Route exact path={'/logout'} component={Logout} />
                  <Route path={'/confidentialite'} component={Legal} />
                  <Route path={'/profil'} component={({ match }) => <MissionFiche profile={true} />} />
                  <Route
                    path={'/fiche/anon/:ficheId'}
                    component={({ match }) => (
                      <MissionFiche missionId={'anon'} ficheId={match.params.ficheId} />
                    )}
                  />
                  <Route component={NoMatch} />
                </Switch>
              </When>
            </Choose>
          </ThemeProvider>
        </div>
      </Router>
    );
  }
}

function mapStateToProps(state) {
  const props = {
    authStateKnown: authStateKnown(state),
    loggedIn: isLoggedIn(state),
    userRole: getCurrentUserRole(state),
  };
  return props;
}
function mapDispatchToProps(dispatch) {
  return {
    onMount: () => dispatch(initialeLogin()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(App));



// WEBPACK FOOTER //
// ./src/components/App.js